import { getUpcomingYearsWithCurrent } from '@helpers/date-formatter'

export const subscriptionWithBenefitsUsageYears = getUpcomingYearsWithCurrent(4)
